import client from "../client";
import * as utility from "utilities/utils";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";
import { ENDPOINTS } from "utilities/endPoints";

import responseResult from "./responseResult.json";
import responseSubmit from "./responseSubmit.json";


const submitFlightSearchRequest = async (params) => {

    const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.FLIGHTS}`;

    try {
        const response = await client.post(url, params); 
        return utility.getResponse(response); 
    }
    catch (error) {
        return utility.getErrorResponse(error);
    }
};


const getFlightsResult = async (flightSearchID) => {

    const url = `${process.env.REACT_APP_QUOTE_PROCESSOR}${ENDPOINTS.QUOTE_PROCESSOR.FLIGHTS}`;

    try {
        const response = await client.get(`${url}?flightSearchID=${flightSearchID || ""}`);
        //const response = responseResult;

        return utility.getResponse(response);
    }
    catch (error) {
        return utility.getErrorResponse(error);
    }
};

export default { submitFlightSearchRequest, getFlightsResult };